export function fmtMin(mins, { compact = false } = {}) {
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return compact
      ? `${h}:${m.toString().padStart(2, "0")}`  // 2:05
      : `${h}h ${m.toString().padStart(2, "0")}min`; // 2h 05min
  }